import { template as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  embedCode: '<p>Dangerously Set Test Embed Code Here</p>',
  header: 'Test Header',
};

export default fakeProps(schema, TestData);
